import { DEFAULT_OVERVIEW_IMAGE_HEIGHT, DEFAULT_OVERVIEW_IMAGE_WIDTH } from '@/constants/project';
import { currentOverviewImageSelector } from '@/redux/project/project.selectors';
import { useSelector } from 'react-redux';
import { OverviewImageLinkConfig, OverviewImageSize } from '../OverviewImageModal.types';
import { useOverviewImageLinkConfigs } from './useOverviewImageLinkElements';
import { useOverviewImageSize } from './useOverviewImageSize';
import { useOverviewImageUrl } from './useOverviewImageUrl';

interface UseOverviewImageArgs {
  containerRect?: DOMRect;
}

interface UseOverviewImageResults {
  imageUrl: string;
  /** size the image is displayed with */
  size: OverviewImageSize;
  /** original size of the image, used as the coordinate system of the link polygons */
  naturalSize: OverviewImageSize;
  linkConfigs: OverviewImageLinkConfig[];
}

const DEFAULT_NATURAL_SIZE: OverviewImageSize = {
  width: DEFAULT_OVERVIEW_IMAGE_WIDTH,
  height: DEFAULT_OVERVIEW_IMAGE_HEIGHT,
};

export const useOverviewImage = ({
  containerRect,
}: UseOverviewImageArgs): UseOverviewImageResults => {
  const currentImage = useSelector(currentOverviewImageSelector);
  const imageUrl = useOverviewImageUrl();
  const size = useOverviewImageSize({ containerRect });
  const linkConfigs = useOverviewImageLinkConfigs();

  const naturalSize = currentImage
    ? { width: currentImage.width, height: currentImage.height }
    : DEFAULT_NATURAL_SIZE;

  return {
    size,
    naturalSize,
    imageUrl,
    linkConfigs,
  };
};
